import * as Headless from '@headlessui/react'
import React, { forwardRef } from 'react'
import { Link as RemixLink } from 'react-router'

export const Link = forwardRef(function Link(
	props: { href: string } & Omit<
		React.ComponentPropsWithoutRef<typeof RemixLink>,
		'to'
	>,
	ref: React.ForwardedRef<HTMLAnchorElement>,
) {
	return (
		<Headless.DataInteractive>
			<RemixLink {...props} to={props.href} ref={ref} />
		</Headless.DataInteractive>
	)
})
